import React from 'react';

import { SimpleTooltip } from '@tanium/react-tooltip';
import { useIsOverflowing } from '@tanium/react-use-is-overflowing';

import { NoOverflow } from '../utils/NoOverflow';

export interface TruncatedLabelProps {
  children: React.ReactNode;
}

/**
 * A label component to display overflowing text in a tooltip.
 */
export const TruncatedLabel = ({ children }: TruncatedLabelProps): JSX.Element => {
  const [isOverflowing, overflowingRef] = useIsOverflowing({ updateOnResize: true });
  return (
    <SimpleTooltip content={isOverflowing && children} placement="top">
      {({ ref }: { ref: React.Ref<HTMLDivElement> }) => (
        <NoOverflow innerRef={ref}>
          <NoOverflow innerRef={overflowingRef}>{children}</NoOverflow>
        </NoOverflow>
      )}
    </SimpleTooltip>
  );
};
